module.exports = __webpack_public_path__ + "img/EA130_1-1.d76591c4.jpg";